(function() {
  var header = {
    init: function() {
      var mainHeader = $('.x-main-header');
      var hamburgerSwitch  = $('.x-hamburger');
      var cssHiddenClass   = 'header__main--hidden';
      var cssFixedClass    = 'nav-switch--fixed'; //fixed hamburger
      var mql = window.matchMedia("screen and (max-width: 1039px)");
      var isNoFixed = $('body').hasClass('nofixed-menu');
      var isFixedMenu = false;

      var setMainMenu =  function() {
        var scrollPosition = $(window).scrollTop();

        if (scrollPosition >= 220 && !isFixedMenu) {
          if (scrollPosition > 300) {
            hamburgerSwitch.addClass(cssFixedClass);
            mainHeader.removeClass(cssHiddenClass);
            isFixedMenu = true;
          }
        }
        else if (scrollPosition < 220 && isFixedMenu) {
          if (scrollPosition <= 300) {
            hamburgerSwitch.removeClass(cssFixedClass);
            isFixedMenu = false;
          }
        }
      }

      var resizeOrientation = function(mql) {
        if (mql.matches) {
          hamburgerSwitch.addClass(cssFixedClass);
        } else if (isNoFixed) {
          hamburgerSwitch.removeClass(cssFixedClass);
        } else {
          setMainMenu();
        }
      }

      window.addEventListener('load', function() {
        if (!mql.matches && !isNoFixed)
          setMainMenu();
      });

      $(window).on('touchstart touchmove scroll', function () {
        if (!mql.matches && !isNoFixed)
          setMainMenu();
      });

      resizeOrientation(mql);
      mql.addListener(resizeOrientation);
    }
  }

  $(document).ready(function() {
    if ($('.x-main-header').length > 0) { header.init(); }
  });

  $('.x-dropdown-trigger').on('mouseenter', function(e) {
    $(this).parent('.x-dropdown-content').addClass('active');
  });

  $('.x-dropdown-content').on('mouseleave', function(e) {
    if($(this).hasClass('active')) {
      $(this).removeClass('active');
    } else {
      $(this).addClass('active');
    }
  });

})();
